import { atom } from "jotai";

export const setPoreeCameraAtom = atom<any | null>(null);